import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('jacket-buyer-guide', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./jacket-buyer-guide-landing')
        ),
);
